import React, { useState, useEffect, useContext } from 'react'
import { DatatableRow, DatatableCell } from '../../atoms/Datatable/Datatable'
import Color from '../../atoms/Color/Color'
import ProssimoArrivo from '../../atoms/ProssimoArrivo/ProssimoArrivo'
import Tooltip from '../../atoms/Tooltip/Tooltip'
import { EMail, Info } from '../../atoms/NewIcons'
import Trans from '../../atoms/Trans/Trans'
import QuantityHandler from '../../atoms/QuantityHandler/QuantityHandler'
import { QuantitaContext } from '../../../context/QuantitaContext'
import { priceNotation, numberNotation, dateIsoToIt, getAltText } from '../../../utils/safe'
import useTrans from '../../../hooks/useTrans'
import NewModal from '../../molecules/NewModal/NewModal'
import MyImage from '../../atoms/MyImage/MyImage'

const DatatableRowProdotto = ({
  ErroreEscludiListinoDiStampa,
  cols,
  id,
  codice,
  taglia,
  prezzo,
  prossimi_arrivi,
  multipli,
  disponibilita,
  disponibilita_reale_maggiore,
  disponibilita_in_opzione,
  data_in_opzione,
  onChangeInputQuantita,
  handleQuantita,
  colore,
  initialValue,
  isEdit,
  imballi,
  sotto_imballi,
  OnClickRichiedi,
  inchiostro,
  articolo,
  service_gift,
  image,
}) => {
  const [massimaQuantitaPrenotabile, setMassimaQuantitaPrenotabile] = useState(0)
  const [massimaQuantita, setMassimaQuantita] = useState(disponibilita ? disponibilita : 0)
  const { getQuantita, getError, insertArticolo, quantita } = useContext(QuantitaContext)
  const [display, setDisplay] = useState(true)

  const t = useTrans()
  const getIncrementer = () => {
    return multipli || multipli > 0
      ? multipli
      : sotto_imballi > 0
      ? sotto_imballi
      : imballi > 0
      ? imballi
      : 1
  }
  useEffect(() => {
    initialValue && insertArticolo(codice, initialValue, multipli, id, prossimi_arrivi)
  }, [])

  useEffect(() => {
    disponibilita && setMassimaQuantita(disponibilita)
  }, [disponibilita])

  useEffect(() => {
    let disp = disponibilita ? disponibilita : 0
    setMassimaQuantitaPrenotabile(
      service_gift
        ? disp
        : prossimi_arrivi
        ? prossimi_arrivi
            .filter((item) => item.prenotabile)
            .reduce((current, quantita) => current + Number(quantita.disponibilita), 0) + disp
        : disp
    )
  }, [prossimi_arrivi, disponibilita])

  const [zoomModalVisible, setZoomModalVisible] = useState(false)
  const [localQuantita, setLocalQuantita] = useState(quantita)

  useEffect(() => {
    setLocalQuantita(getQuantita(codice))
  }, [quantita, codice])

  // TODO: valore di Color?
  return (
    <>
      <NewModal
        className="datatable-prodotto__modal"
        visible={zoomModalVisible}
        onClose={() => setZoomModalVisible(false)}
      >
        {/* Main Image */}
        <div className="main__image__wrapper">
          <div className="main__image">
            <MyImage
              className=""
              src={image?.url}
              alt={getAltText(image) || articolo?.titolo}
              title={articolo?.titolo}
              width={800}
              height={800}
              loading="eager"
              onClick={() => setZoomModalVisible(false)}
            />
          </div>
        </div>
      </NewModal>
      <DatatableRow
        error={
          ErroreEscludiListinoDiStampa?.error
            ? ErroreEscludiListinoDiStampa?.error
            : getError(codice)
            ? t(
                `Attenzione: articolo acquistabile solo a multipli di {0} pezzi. Ti invitiamo ad aggiornare le quantità inserite.`,
                [multipli]
              )
            : ''
        }
      >
        <DatatableCell col={cols.codice} /* error={'Esempio errore cella'} */>
          {colore.nome}
          <br/>
          {codice}
        </DatatableCell>
        <DatatableCell col={cols.colore} contentClassName="datatable-cell__content__image">
          <Color
            onClick={() => (image ? setZoomModalVisible(true) : undefined)}
            img={image || colore?.image}
            colorName={colore?.codice + ' - ' + colore?.nome}
            variant={image ? 'image' : ''}
          />
        </DatatableCell>
        <DatatableCell col={cols.taglia}>{taglia}</DatatableCell>
        {cols?.inchiostro && <DatatableCell col={cols?.inchiostro}>{inchiostro}</DatatableCell>}
        <DatatableCell col={cols.prezzo}>{priceNotation(prezzo, 3)} €</DatatableCell>
        <DatatableCell col={cols.disponibilita}>
          {disponibilita > 0 ? (
            <div className="datatable-prodotto__disponibilita">
              <div className="datatable-prodotto__disponibilita-label">
                <span>
                  {disponibilita_reale_maggiore && <Trans chiave="Più di" />}{' '}
                  {numberNotation(disponibilita)}
                </span>
                {disponibilita_reale_maggiore && (
                  <Tooltip
                    label={t(
                      "Per quantità superiori a quella indicata contattare l'ufficio commerciale"
                    )}
                  >
                    <Info className="datatable-prodotto__richiedi-icon datatable-prodotto__richiedi-icon--info" />
                  </Tooltip>
                )}
              </div>
            </div>
          ) : (
            <div className="datatable-prodotto__richiedi">
              {display && (
                <>
                  <EMail className="datatable-prodotto__richiedi-icon datatable-prodotto__richiedi-icon--email" />
                  <span
                    className="datatable-prodotto__richiedi-label"
                    onClick={() => (OnClickRichiedi(id), setDisplay(false))}
                  >
                    {t('Richiedi')}
                  </span>
                  <Tooltip
                    label={t(
                      'Il prodotto non è disponibile, ma puoi essere avvisato quando tornerà nuovamente disponibile'
                    )}
                  >
                    <Info className="datatable-prodotto__richiedi-icon datatable-prodotto__richiedi-icon--info" />
                  </Tooltip>
                </>
              )}
            </div>
          )}
          {disponibilita_in_opzione > 0 && (
            <div className="datatable-prodotto__in-opzione">
              <div className="datatable-prodotto__in-opzione-label">
                <span>
                  {t('In opzione')} - {numberNotation(disponibilita_in_opzione)}
                  {t('pz')}
                </span>
                <Tooltip label={t('Merce in prenotazione')}>
                  <Info className="datatable-prodotto__richiedi-icon datatable-prodotto__richiedi-icon--info" />
                </Tooltip>
              </div>
            </div>
          )}
        </DatatableCell>
        <DatatableCell col={cols.prossimi_arrivi}>
          {prossimi_arrivi &&
            prossimi_arrivi
              .filter((item) => !service_gift || item.prenotabile)
              .map((prossimo, i) => (
                <div key={i}>
                  <ProssimoArrivo prossimo_arrivo={prossimo} />
                </div>
              ))}
        </DatatableCell>
        <DatatableCell col={cols.quantita} contentClassName="datatable-cell__content__quantity">
          {massimaQuantitaPrenotabile > 0 && (
            <QuantityHandler
              inputDisabled={false}
              value={getQuantita(codice)}
              onValueChange={(newVal, action) => {
                switch (action) {
                  case 'remove':
                  case 'add':
                    handleQuantita(
                      id,
                      codice,
                      getIncrementer(),
                      massimaQuantitaPrenotabile,
                      prossimi_arrivi,
                      disponibilita,
                      action,
                      isEdit,
                      multipli ? false : true,
                      articolo?.escludi_da_listino_di_stampa
                    )
                    break
                  case 'set':
                    onChangeInputQuantita(
                      id,
                      codice,
                      newVal,
                      massimaQuantitaPrenotabile,
                      multipli,
                      disponibilita,
                      prossimi_arrivi,
                      isEdit,
                      articolo?.escludi_da_listino_di_stampa
                    )
                    break
                }
              }}
            />
          )}
        </DatatableCell>
      </DatatableRow>
    </>
  )
}

export default React.memo(DatatableRowProdotto)
